// TODO getStatus is called from multpiple locations
// (version + backendchecker), maybe provide status
// via context or so
export async function getStatus() {
  const url = process.env.REACT_APP_STATUS_URL;

  try {
    const result = await fetch(url, { cache: 'no-store' });
    const json = await result.json();
    return json;
  } catch (error) {
    // console.log('checkSatus error:');
    // console.log(error);
    return null;
  }
}
